export default "__VITE_ASSET__PJ7_jXwE__"